import './themes/default/borderRadius/index.js';
import './themes/default/borderWidth/index.js';
import { ColorAll } from './themes/default/color/index.js';
import './themes/default/shape/index.js';
import './themes/default/size/index.js';
import './themes/default/spacing/index.js';
import './theming/themes/caviar.js';
import './theming/themes/merchant.js';
import './theming/themes/merchant-next.js';
import './theming/icons/constants.js';
import './theming/logo/constants.js';
import './theming/typography/constants.js';
import 'lodash.clonedeep';
import 'lodash.merge';
import 'react';
import ExecutionEnvironment from 'exenv';

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

if (ExecutionEnvironment.canUseDOM) {
  require('wicg-focus-ring');
}

var DEFAULT_FOCUS_WIDTH = 3;

var getFocusStyles = function getFocusStyles() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$boxShadows = _ref.boxShadows,
      shadows = _ref$boxShadows === void 0 ? [] : _ref$boxShadows,
      _ref$focusColor = _ref.focusColor,
      focusColor = _ref$focusColor === void 0 ? ColorAll.SystemBlue60 : _ref$focusColor,
      _ref$focusWidth = _ref.focusWidth,
      focusWidth = _ref$focusWidth === void 0 ? DEFAULT_FOCUS_WIDTH : _ref$focusWidth,
      _ref$shouldUseFocusRi = _ref.shouldUseFocusRing,
      shouldUseFocusRing = _ref$shouldUseFocusRi === void 0 ? true : _ref$shouldUseFocusRi,
      _ref$shouldBeInset = _ref.shouldBeInset,
      shouldBeInset = _ref$shouldBeInset === void 0 ? false : _ref$shouldBeInset;

  var boxShadows = ["0px 0px 0px ".concat(focusWidth, "px ").concat(focusColor)].concat(_toConsumableArray(shadows)).join(', ');

  if (shouldUseFocusRing) {
    return "\n      outline: none;\n      .js-focus-ring &.focus-ring {\n        outline: none;\n        box-shadow: ".concat(shouldBeInset ? 'inset ' : '').concat(boxShadows, ";\n      }\n    ");
  }

  return "\n    outline: none;\n    box-shadow: ".concat(shouldBeInset ? 'inset ' : '').concat(boxShadows, ";\n  ");
};

export { getFocusStyles as default };
